import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFamilyMe = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a,.b{fill:none;}.b{stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M0,0H24V24H0Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M11.861,3.66a2.252,2.252,0,1,1-3.185,0,2.252,2.252,0,0,1,3.185,0",
			transform: "translate(-3.356 3.912)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M11.861,3.66a2.252,2.252,0,1,1-3.185,0,2.252,2.252,0,0,1,3.185,0",
			transform: "translate(6.82 3.912)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M7.1,3.954H.564A.565.565,0,0,1,0,3.391V2.826A2.461,2.461,0,0,1,1.58.771,7.877,7.877,0,0,1,5.086,0a6.327,6.327,0,0,1,4.6,1.591A3.612,3.612,0,0,0,7.875,2.3,1.884,1.884,0,0,0,7.1,3.791v.162Z",
			transform: "translate(2.32 13.136)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M9.121,3.954H2.59A2.7,2.7,0,0,0,0,1.593,6.306,6.306,0,0,1,4.6,0,7.891,7.891,0,0,1,8.105.769a2.46,2.46,0,0,1,1.58,2.053v.564A.567.567,0,0,1,9.121,3.954Z",
			transform: "translate(12.242 13.136)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M0,0H24V24H0Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M10.091,3.356a1.216,1.216,0,1,1-1.719,0,1.216,1.216,0,0,1,1.719,0",
			transform: "translate(2.874 7.349)"
		})
	]
});
export default SvgFamilyMe;
